var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 98 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_4876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1381 128.855C27.2019 132.213 35.8449 134.002 45.6483 134.002H47.6519C73.5811 134.002 86.2261 122.444 92.3391 112.771C97.0876 105.101 98.35 95.5357 95.8199 86.3931C90.4428 67.4759 74.0001 49.9245 66.093 42.3565C68.3061 40.257 69.6813 37.3112 69.6813 33.9477C69.6813 29.9575 67.5702 26.594 64.5137 24.4891L71.8944 5.78613C72.5229 4.20612 72.2113 2.42259 70.9436 1.15859C69.7833 0.0017041 67.8871 -0.308941 66.4099 0.317705C48.1784 7.99278 31.2038 0.424824 31.1017 0.424824C29.5171 -0.308941 27.7283 0.0017041 26.4606 1.15859C25.1982 2.31547 24.7739 4.10436 25.3057 5.67901L32.262 24.3873C29.0981 26.4869 26.885 29.9575 26.885 33.9477C26.885 37.4183 28.3622 40.3588 30.6774 42.5654C23.5115 49.5067 9.59885 64.2195 3.0615 80.8229C-4.31384 99.4241 3.16893 120.548 20.1381 128.855ZM38.6919 30.5895H57.8743C59.7705 30.5895 61.2477 32.1642 61.2477 33.9477C61.2477 35.8437 59.7705 37.4183 57.8743 37.4183H38.6919C36.7904 37.4183 35.3185 35.8437 35.3185 33.9477C35.3185 32.1642 36.7904 30.5895 38.6919 30.5895Z",
    fill: "#00A90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_4876",
    x: 0.227539,
    y: 0,
    width: 96.8701,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_4876"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.09a025d7f4cac3b799de1af5dbdbfbe8.svg";
export { ForwardRef as ReactComponent };